import PropTypes from 'prop-types'
import { Divider, Grid, Box } from '@mui/material'
import Typography from '@app/stories/Typography'
import Button from '@app/stories/Button'
import OrderChatView from '@app/components/OrderChatView'
import { useCurrentUser } from '@app/context/CurrentUser'
import generatePDF from '@app/libs/pdf'
import usePDFs from '@app/hooks/usePDFs'
import Icon from '@app/stories/Icons'

const OriginalOrderBar = ({ order }) => {
  const { authData } = useCurrentUser()
  const { createOrderWithLogo } = usePDFs()

  return (
    <>
      <Divider />
      <Box
        width='100%'
        display='flex'
        alignItems='center'
        gap='16px'
        padding='8px'
        justifyContent='space-between'
        sx={{
          flexDirection: {
            xs: 'column',
            md: 'row',
          },
        }}
      >
        <Box
          sx={{
            width: {
              xs: '100%',
              md: '50%',
            },
          }}
        >
          <Typography
            variant='h4'
            style={{
              marginBottom: '0px',
              textTransform: 'capitalize',
            }}
          >
            Origin: {order?.orderType}
          </Typography>
        </Box>
        <Box display='flex' gap='8px'>
          {authData.roles.includes('PROVIDER') && order && (
            <Box
              display='flex'
              flexDirection='column'
              justifyContent='flex-start'
              alignItems='center'
              width='50%'
              gap='4px'
            >
              <Button
                variant='contained'
                size='small'
                style={{
                  height: '40px',
                  width: '40px',
                  minWidth: '40px',
                  borderRadius: '50%',
                  display: 'flex',
                  justifyContent: 'center',
                  alignItems: 'center',
                  backgroundColor: '#eee',
                  color: '#666',
                }}
                onClick={() => {
                  generatePDF(createOrderWithLogo(order), `Order_${order.id}`)
                }}
              >
                <Icon name='print' color='inherit' size='large' />
              </Button>
              <Typography
                variant='body1'
                family='poppins'
                align='center'
                style={{ lineHeight: '1.2', whiteSpace: 'nowrap' }}
              >
                Print Order
              </Typography>
            </Box>
          )}
          <Box display='flex' alignItems='center' width='100%'>
            <OrderChatView order={order} chatID={order.id} color='#652d92' />
          </Box>
        </Box>
      </Box>
    </>
  )
}

OriginalOrderBar.propTypes = {
  order: PropTypes.object.isRequired,
}

export default OriginalOrderBar
